import "~css/app.css";
import defo from "@icelab/defo";
import { views } from "./views";

defo({ views });
